<template lang="pug">
  v-row(justify='center')
    v-dialog(v-model='dialog')
        v-card()
          v-card-title(class="grey lighten-2")
            v-row
              v-col(sm="11" md="11") 
                span(style="margin-left:-10px;margin-bottom:10px") List Email Logs 
              v-col(sm="1" md="1" )   
                v-icon.mr-2(
                  color="black",
                  dark,
                  style="float:right"
                  @click="dialog = false"
                ) mdi-close
          v-card-text(style="padding:10px")
              v-data-table.elevation-1(
                :headers="ip.headers",
                :must-sort="true",
                :sort-by="pagination.sortBy",
                :sort-desc="pagination.descending",
                :items="ip.items",
              )
                template(v-slot:item.createdAt="{ item }")
                  label {{ formatDate(item.createdAt )}} 
                  
</template>

<script>
import { mapState } from "vuex";
import axios from "axios";
import helper from "../helper/index.js";

export default {

name:"ModalListEmailLogs",
props:{
  'onClose': Boolean,
  'dataIpNo': String,
  "actionFor": {default: null, type: String}
},
data () {
      return {
        phoneNumLength: 15,
        dialog: false,
        valid: true,
        name :"",
        nohp:"",
        email:"",
        emailRules: [
          v => !!v || 'E-mail is required',
          v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
        ],
        ip: {
          headers: [
            {
              text: 'Nomor IP',
              align: 'start',
              sortable: false,
              value: 'ipNo',
            },
            { text: 'Tanggal', value: 'createdAt' },
            { text: 'Subject', value: 'subject',  width: '520px'},
            { text: 'Attechment', value: 'attachments[0].filename', width: '280px'},
            { text: 'To', value: 'to' },
            // { text: 'Action', value: 'actions' },
          ],
          items: []
        }, 
        pagination: {
          sortBy: ["ipNo"],
          descending: [true],
        },
      }
    },
  computed: {
    ...mapState(["API_URL",'visitorRules'])
  },
  mounted() {

  },
  methods: {
    formatDate:helper.formatDate,
  },
  watch : {
    dialog(param){
      if (!param) return;
      const data = {ipNo : this.dataIpNo}
      const queryUrl = this.actionFor === 'extendWaskat' ? '?actionFor=extendWaskat' : '';
      const config = {
        method: "post",
        url: `${this.API_URL}/v1/requests/admin/email-logs` + queryUrl,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.token}`,
        },
        data: data,
      };
      axios(config).then((res) => {
        this.ip.items = res.data.data
      }).catch((err) => {
        console.log(err.response)
      })

    }
  }
}
</script>

<style>

</style>